import blogsData from '../data/blogs.json';
import projectsData from '../data/projects.json';

const KEYS = {
  BLOGS: 'twe-blogs',
  PROJECTS: 'twe-projects',
  SUBSCRIBERS: 'twe-subscribers',
  INITIALIZED: 'twe-initialized',
};

function init() {
  if (!localStorage.getItem(KEYS.INITIALIZED)) {
    localStorage.setItem(KEYS.BLOGS, JSON.stringify(blogsData));
    localStorage.setItem(KEYS.PROJECTS, JSON.stringify(projectsData));
    localStorage.setItem(KEYS.SUBSCRIBERS, JSON.stringify([]));
    localStorage.setItem(KEYS.INITIALIZED, '1');
    return;
  }

  // Merge any new blogs from the JSON source that aren't in localStorage yet
  const storedBlogs = JSON.parse(localStorage.getItem(KEYS.BLOGS) || '[]');
  const storedBlogIds = new Set(storedBlogs.map((b) => b.id));
  const newBlogs = blogsData.filter((b) => !storedBlogIds.has(b.id));
  if (newBlogs.length) {
    localStorage.setItem(KEYS.BLOGS, JSON.stringify([...newBlogs, ...storedBlogs]));
  }

  // Merge any new projects from the JSON source that aren't in localStorage yet
  const storedProjects = JSON.parse(localStorage.getItem(KEYS.PROJECTS) || '[]');
  const storedProjectIds = new Set(storedProjects.map((p) => p.id));
  const newProjects = projectsData.filter((p) => !storedProjectIds.has(p.id));
  if (newProjects.length) {
    localStorage.setItem(KEYS.PROJECTS, JSON.stringify([...storedProjects, ...newProjects]));
  }
}

// ── Blogs ──────────────────────────────────────────────────────────────────
function getBlogs() {
  init();
  return JSON.parse(localStorage.getItem(KEYS.BLOGS) || '[]');
}

function addBlog(blog) {
  const blogs = [blog, ...getBlogs()];
  localStorage.setItem(KEYS.BLOGS, JSON.stringify(blogs));
  return blogs;
}

function updateBlog(id, updates) {
  const blogs = getBlogs().map((b) => (b.id === id ? { ...b, ...updates } : b));
  localStorage.setItem(KEYS.BLOGS, JSON.stringify(blogs));
  return blogs;
}

function deleteBlog(id) {
  const blogs = getBlogs().filter((b) => b.id !== id);
  localStorage.setItem(KEYS.BLOGS, JSON.stringify(blogs));
  return blogs;
}

// ── Projects ───────────────────────────────────────────────────────────────
function getProjects() {
  init();
  return JSON.parse(localStorage.getItem(KEYS.PROJECTS) || '[]');
}

function addProject(project) {
  const projects = [...getProjects(), project];
  localStorage.setItem(KEYS.PROJECTS, JSON.stringify(projects));
  return projects;
}

function addProjects(newProjects) {
  const projects = [...getProjects(), ...newProjects];
  localStorage.setItem(KEYS.PROJECTS, JSON.stringify(projects));
  return projects;
}

function updateProject(id, updates) {
  const projects = getProjects().map((p) => (p.id === id ? { ...p, ...updates } : p));
  localStorage.setItem(KEYS.PROJECTS, JSON.stringify(projects));
  return projects;
}

function deleteProject(id) {
  const projects = getProjects().filter((p) => p.id !== id);
  localStorage.setItem(KEYS.PROJECTS, JSON.stringify(projects));
  return projects;
}

// ── Subscribers ────────────────────────────────────────────────────────────
function getSubscribers() {
  init();
  return JSON.parse(localStorage.getItem(KEYS.SUBSCRIBERS) || '[]');
}

function addSubscriber(email) {
  const subs = getSubscribers();
  if (subs.find((s) => s.email === email)) {
    return { success: false, message: "You're already subscribed!" };
  }
  const updated = [...subs, { email, subscribedAt: new Date().toISOString() }];
  localStorage.setItem(KEYS.SUBSCRIBERS, JSON.stringify(updated));
  return { success: true, message: "Welcome aboard! You're subscribed." };
}

const dataStore = {
  getBlogs,
  addBlog,
  updateBlog,
  deleteBlog,
  getProjects,
  addProject,
  addProjects,
  updateProject,
  deleteProject,
  getSubscribers,
  addSubscriber,
};

export default dataStore;
